module.exports = __webpack_public_path__ + "static/media/637703403478300000_1638711762929.cb6a9aae.jfif";